(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestie-box-items-carousel"] && !Shopify.designMode) return;
  try {
    
  class BestieCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bbx-carousel__track');
      this.prev = this.querySelector('.bbx-carousel__arrow--prev');
      this.next = this.querySelector('.bbx-carousel__arrow--next');
      if (!this.track || !this.prev || !this.next) return;

      // Only reveal arrows for fine-pointer (non-touch) input.
      if (window.matchMedia('(pointer: fine)').matches) {
        this.prev.hidden = false;
        this.next.hidden = false;
      }

      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    scrollByCard(dir) {
      const card = this.track.querySelector('.bbx-carousel__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      this.prev.disabled = x <= 1;
      this.next.disabled = x >= max - 1;
    }
  }

  if (!customElements.get('bestie-carousel')) {
    customElements.define('bestie-carousel', BestieCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestie-reviews"] && !Shopify.designMode) return;
  try {
    
  class BestieReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-reviews-track]');
      this.prev = this.querySelector('.bb-reviews__arrow--prev');
      this.next = this.querySelector('.bb-reviews__arrow--next');
      if (!this.track || !this.prev || !this.next) return;

      this.desktop = window.matchMedia('(min-width: 990px)');
      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.desktop.addEventListener('change', () => this.reveal());
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
      this.reveal();
    }

    reveal() {
      const on = this.desktop.matches;
      this.prev.hidden = !on;
      this.next.hidden = !on;
      if (on) this.updateArrows();
    }

    scrollByCard(dir) {
      const card = this.track.querySelector('.qc');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      this.prev.disabled = x <= 1;
      this.next.disabled = x >= max - 1;
    }
  }

  if (!customElements.get('bestie-reviews-carousel')) {
    customElements.define('bestie-reviews-carousel', BestieReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
